import { keyframes, css } from 'styled-components'
import { CssAnimationProps } from 'animations'

const outFrom = keyframes`
  0% {
    transform: translateY(-3%);
  }
  20% {
    transform: translateY(-3%);
  }
  70% {
    transform: translateY(0);
  }
`

const animation = css<CssAnimationProps>`
  animation: ${outFrom} ${({ animationDuration }) => animationDuration || '.7s'} ease-in;
  transition-property: transform;
`

export default animation
